<mat-card class="bulk-update-container">
  <mat-card-header>
    <mat-card-title>
      <h3>{{ 'OrganizationDetails.BulkUpdate.ProductList' | translate }}</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider class="divider"></mat-divider>

    <div class="relative flex-col">
      <span class="inline-flex flex-row text-sm font-bold">
        {{ 'OrganizationDetails.BulkUpdate.TankCountNeedingUpdates' | translate }}: 
        <mat-spinner *ngIf="isLoading" [diameter]="20" class="metadata-spinner"></mat-spinner>
        <span *ngIf="!isLoading">{{ tankCountNeedingUpdates }}</span>
      </span>

      <button class="refresh-button" mat-stroked-button (click)="onRefreshClick()" [disabled]="isPageLoading || isMetadataLoading" siteUsageTracker
        [logCategory]="'OrganizationDetails-BulkUpdate'"
        [logName]="'RefreshButtonClick'"
        [logData]="orgId"
      >
        <svg-icon src="assets/svg/refresh.svg"
                  tooltip="{{ 'OrganizationDetails.BulkUpdate.RefreshButtonTooltip' | translate }}">
        </svg-icon>
        {{ 'OrganizationDetails.BulkUpdate.RefreshButton' | translate }}
      </button>
    </div>

    <div class="table-container" [class.loading]="isPageLoading">
      <!-- Loading overlay for table -->
      <div class="table-loading-overlay" *ngIf="isPageLoading">
        <mat-spinner [diameter]="40" class="table-spinner"></mat-spinner>
        <div class="loading-text">Loading</div>
      </div>

      <table class="product-candidate-table">
        <!--header-->
        <thead class="product-candidate-table-header">
          <tr class="mat-row">
            <ng-container *ngFor="let column of displayedColumns">
              <td class="mat-cell product-candidate-header-column" [ngStyle]="{'min-width':column.width}" title="{{'OrganizationDetails.BulkUpdate.' + column.key | translate }}">
                {{ 'OrganizationDetails.BulkUpdate.' + column.key | translate }}
              </td>
            </ng-container>
          </tr>
        </thead>

        <!--Product Candidate List-->
        <tbody class="product-candidate-table-body" *ngIf="!isLoading">
            <tr *ngFor="let product of orgCandidateProductList; let i = index" [ngClass]="product.selected === true ? 'product-candidate-row-selected' : 'product-candidate-row-unselected'">
                <td *ngFor="let column of displayedColumns" class="mat-cell" [ngStyle]="{'min-width':column.width}">
                  <span *ngIf="column.key == 'selected'">
                    <mat-checkbox class="product-candidate-checkbox" [(ngModel)]="product[column.key]" (change)="onCandidateSelectionChanged(i)"
                      siteUsageTracker
                      [logCategory]="'OrganizationDetails-BulkUpdate'"
                      [logName]="'CandidateSelectionChanged'"
                      [logData]="product?.productId"
                    ></mat-checkbox>
                  </span>
                  <span *ngIf="column.key != 'selected'">
                    {{ product[column.key]}}
                  </span>
                </td>
            </tr>
        </tbody>
      </table>
    </div>

    <mat-paginator
      #paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="pageSize"
      [length]="totalCandidateProducts"
      [disabled]="isPageLoading"
      showFirstLastButtons>
    </mat-paginator>

  </mat-card-content>
  <mat-card-footer>
    <mat-card-actions>
      <div class="bulk-update-actions">
        <!--Available Products List-->
        <div style="position: relative;">
          <div class="metadata-loading-overlay" *ngIf="isMetadataLoading">
            <mat-spinner [diameter]="20" class="metadata-spinner"></mat-spinner>
            <div class="loading-text">Loading</div>
          </div>
          <ejs-dropdownlist class="product-filter-dropdown"
                            cssClass="e-outline"
                            #ddlProducts
                            id="ddlelement"
                            [dataSource]="ddlData"
                            [fields]="ddlFields"
                            placeholder="{{ 'OrganizationDetails.BulkUpdate.SelectProducts' | translate}}"
                            showDropDownIcon="true"
                            [allowFiltering]='true'
                            (change)="onProductDropDownSelectChanged($event)"
                            popupHeight='200px'
                            [enabled]="!isMetadataLoading"
                            siteUsageTracker
                            [logCategory]="'OrganizationDetails-BulkUpdate'"
                            [logName]="'ProductDropDownSelectChanged'"
                            [logData]="orgId"
                            >
          </ejs-dropdownlist>
        </div>
        <div class="action-buttons">
                  <mat-spinner *ngIf="showSpinner"
                     [diameter]="20"
                     class="p2 mr-4">
        </mat-spinner>
        <button mat-button
                class="bulk-update-footer-button move-button"
                (click)="onCancelClick()"
                appMaterialElevation
                [defaultElevation]="0"
                [raisedElevation]="1"
                siteUsageTracker
                [logCategory]="'OrganizationDetails-BulkUpdate'"
                [logName]="'CancelButtonClick'"
                [logData]="orgId"
                >
          {{ 'Dialog.Cancel' | translate }}
        </button>
        <button mat-raised-button
                class="bulk-update-footer-button green-action-button move-button"
                (click)="onUpdateValuesButtonClicked()"
                [disabled]="isUpdateValuesButtonDisabled"
                siteUsageTracker
                [logCategory]="'OrganizationDetails-BulkUpdate'"
                [logName]="'UpdateValuesButtonClick'"
                [logData]="orgId"
                >
          {{ 'OrganizationDetails.BulkUpdate.UpdateValues' | translate }}
        </button>
        </div>
      </div>
     </mat-card-actions>
  </mat-card-footer>
</mat-card>
